<template lang="html">
  <div class="eachendcompiler">
    <!-- <div
      class="eachendcompiler--header"
      v-show="isShowReel && isShowOverlay && isShowPython"
    >
      <QuestionMenu
        class="eachendcompiler--header-questionmenu"
        :class='{"eachendcompiler--header-questionmenu-problemSolved":isShowProblemSolved}'
        role="student"
        :bundle="params.bundle"
        :current="index"
        :needLock="isNeedLock"
        :needCorrect="isNeedCorrect"
        @selectIndex="selectIndex"
        @modify-title="modifyTitle"
      />
      
     <p v-show='isShowTipText' class='eachendcompiler--tipText'>请务必登录学而思客户端监考，否则将取消考试成绩</p>
    </div> -->
    <!-- <QuestionToast
      v-if="isShowReel"
      :bundleList="params.bundle"
      :propCurrentIndex="index"
      :isNeedSubmit="isNeedSubmit"
      :isDisabled="!isShowOverlay"
      @selectIndex="selectIndex"
      @submit="handleSubmit"
    /> -->
    <MainCompiler
      class="eachendcompiler--main"
      v-show="params.bundle[0].category !== -1"
      :params="params"
      :index="index"
      :isCmLast.sync="isCmLast"
      :solutionError="solutionError"
      @compilerLoaded="handleLoaded"
      @updateBundle="handleUpdate"
      @choiceEnsure="handleChoiceEnsure"
      @choiceFinish="handleChoiceFinish"
      @cppPageStatus="handleCppPage"
      @cppFinish="handleCppFinish"
      @cmReport="handleCmReport"
      @cmFinish="handleCmFinish"
      @cmRetry="handleCmRetry"
      @paperQuestionNext="handleNext"
      @paperQuestionEnsure="handlePaperEnsure"
      @saved="handleSaved"
      @focus="updateFocusState(true, 'compiler')"
      @blur="updateFocusState(false, 'compiler')"
    />
    <div
      class="eachendcompiler--mask"
      v-if="isNeedDialog"
    >
      <div class="eachendcompiler--dialog">
        <i class="eachendcompiler--dialog-icon"></i>
        <div class="eachendcompiler--dialog-txt">
          <h3>{{modal.title}}</h3>
          <h5>{{modal.label}}</h5>
        </div>
        <div
          class="eachendcompiler--dialog-btn"
          @click="handleDirectBack"
        >{{modal.btnLabel}}</div>
      </div>
    </div>
    <div
      class="eachendcompiler--mask"
      v-if="isNeedPre"
    ></div>

    <Houboshi
      v-if="hbsDataloaded && isShowPython || hbsParams.hideTools"
      ref="hbs"
      class="houboshi"
      :role="1"
      :token="token"
      :hbsParams="hbsParams"
      :isShowTools="false"
      :loginType='loginType'
      @pointerdown.native.capture="markSuppressNextBanoutBlur"
      @mousedown.native.capture="markSuppressNextBanoutBlur"
      @touchstart.native.capture="markSuppressNextBanoutBlur"
      @click.native.capture="markSuppressNextBanoutBlur"
      @close="handleHbsClose"
    ></Houboshi>
    
    <Dialog
      :visible="isShowDialog"
      :defaultClazz="false"
    >
      <div>
        <img width="413" height="358" src="~@/assets/challenge_completed.png" />
      </div>
      <div slot="footer">
        <Button
          size="mini"
          class="eachendcompiler--dialog-button"
          @click="handleBack"
        >
          完成
        </Button>
      </div>
    </Dialog>
    <!-- 防止拖动时卡顿添加遮罩 -->
    <!-- 交卷弹窗 -->
    <div
      v-if="isDragging && isShowOverlay"
      class="eachendcompiler--drag-mask"
    ></div>
    <modify-sa-title
      ref="modifysa"
      :current-exercise.sync="params.bundle[index]"
    />
    <answerConfirm
      :visible.sync='isHandDialog'
      :bundleList="params.bundle"
      :totalScore='params.totalScore'
      :isActiveSubmission='isActiveSubmission'
      @handleHandSubmit='handleHandSubmit'
      @handleBack='handleBack'
    />
    <Button
      type="text"
      class="eachendcompiler--problemSolved"
      v-show="isShowProblemSolved"
      @click="showProblemSolved"
    >
      查看题解
    </Button>
    <ProblemSolved
      :visible.sync='isShowProblemSolvedDialog'
      :index="index"
      :bundleList="params.bundle"
    />
  </div>
</template>

<script type="text/babel">
import { mapState, mapGetters } from 'vuex';
import 'katex/dist/katex.min.css';
import '../../assets/styles/katex.custom.css';
import {
  // getSubject,
  updateBundle,
  updateStudentAnswer,
  // getCompetitionStatus,
  updatePaperAnswer,
  saveProject,
  recordSubmitTime,
  getPracticesSolution,
  getSubjectSpractice
} from '@/services/student';
import { saveCMUrl} from '@/services/teacher.js'
// import loading from '@/utils/loading';
import Dialog from '@/components/Dialog.vue';
import Button from '@/components/Button.vue';
// import CountDown from '@/components/CountDown1.vue';

import XEventSource from '@/utils/x-eventsource';
// import QuestionMenu from '@/components/QuestionMenu.vue';
import MainCompiler from '@/components/MainCompiler.vue';
import ModifySaTitle from '@/components/modifySaTitle.vue';
// import QuestionToast from '@/components/QuestionToast.vue';
import { flatMapDeep } from 'lodash';
import { errorHandler } from '@/utils/errorHandler';
import answerConfirm from '@/components/answerConfirm.vue'
import ProblemSolved from '@/components/ProblemSolved.vue'
// import HandInPaper from '@/components/HandInPaper.vue';
// import { Message } from 'element-ui';

export default {
  name: 'StudentCompiler',

  components: {
    Button,
    Dialog,
    // QuestionMenu,
    MainCompiler,
    // CountDown,
    ModifySaTitle,
    // QuestionToast,
    answerConfirm,
    ProblemSolved,
    // HandInPaper,
  },

  data() {
    return {
      params: {
        bundle: [
          {
            category: -1,
          },
        ],
        questionIndex: 0,
        questionCount: 1,
      },
      index: 0,
      isShowOverlay: false,

      // 弹窗相关
      isNeedDialog: false,
      modal: {
        title: '',
        label: '',
        btnLabel: '',
      },

      isShowDialog: false,

      // 题组展示相关
      isShowReel: true,
      isNeedLock: false,
      isShowPython: false,
      isNeedCorrect: false,
      practiceIndex: null,
      // 特殊遮罩
      isNeedPre: false,

      // 猴博士相关
      hbsParams: {
        footerIcon: 'light'
      },
      hbsDataloaded: false,
      isCmLast:false,
      // 提交按钮
      isNeedSubmit: true,
      isDragging: false,
      count:5,
      isHandSubmit:false,
      timer:null,
      handBtnText:'',
      isHandDialog:false,
      isClearTimer:false,
      cppCategoryList:[4,9],
      notShowHBSCtype: [13],
      isActiveSubmission:false,
      isAlreadySubmit:false,
      isShowProblemSolvedDialog:false,
      xeventsource: null,
      eventsourceTimer: null,
      solutionTimer: null,
      solutionError: false,

      // 页面焦点状态
      focus: false, // 上一次综合的焦点状态
      suppressNextBanoutBlur: false,
      suppressBanoutBlurTimer: null,
    };
  },

  computed: {
    ...mapState({
      competitionId: state => state.router.id,
      loginType:state => state.router.loginType,
      isSerial:state=>state.router.isSerial,
    }),
    ...mapGetters([
      'tokenKey',
      'xilieTokenKey',
    ]),
    current() {
      return this.index + 1;
    },

    token() {
      return this.params.token;
    },
    // handBtnText(){
    //   let text = this.count === 1? '提交' : this.count+'s'
    //   return text
    // }
    isShowTipText(){
      return [1,5,6].includes(this.params.bundle[this.index].category)
    },
    countDownText(){
      return this.params.timingFlag === 0 ? '距离收题:' : '答题时间还剩:';
    },
    isCountDown(){
      return  !this.isNeedDialog && 
      this.params.timingFlag!== -1 && 
      this.params.countDownTime > 0 && !this.isAlreadySubmit? true : false
    },
    isShowProblemSolved(){
      let arr = [2,3,8,4,9];
      const { category,reviewContent } = this.params.bundle[this.index];
      if(arr.includes(category) && this.params.bundleExamStatus === 1 && reviewContent) return true;
      return false;
    },
  },

  methods: {

    // 题解弹窗
    showProblemSolved(){
      this.isShowProblemSolvedDialog = true;
    },
    handleNext() {
      if (this.index < this.params.bundle.length - 1) {
        this.index += 1;
      }
      if (this.params.questionIndex < this.params.questionCount - 1) {
        window.parent.postMessage(
          JSON.stringify({
            type: 'question_next',
            content: {
              studentId: this.params.studentId,
              questionId: this.params.questionId,
            }
          }),
          '*'
        )
      }
    },
    showDialog(info) {
      this.modal = {
        title: '提交成功',
        label: '竞赛本部分全部题目已成功提交',
        btnLabel: '返回',
      };
      if (info) this.modal = info;
      this.isNeedDialog = true;
      this.isClearTimer = true;
    },
    handleHandBack(){
      clearInterval(this.timer);
      this.isHandSubmit = false;
      this.count = 5;
      this.isHandDialog = false;
    },
    async handleHandSubmit(){
      try {
        const { status } = await saveProject({
          bundleId: this.params.bundleId,
        });
        if(status === 200) {
          this.destroyEventsource()
          // 记录试卷提交时间
          recordSubmitTime({
            competitionId: this.competitionId,
            bundleId: this.params.bundleId,
            type: 1
          })
        }
        this.isHandDialog = false;
        this.showDialog(); 
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error)
      }
     
    },
    getCode() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if(this.count > 1){
          this.count--
          this.isHandSubmit = false
        }else{
          clearInterval(this.timer);
          this.isHandSubmit = true;
          this.count = 5;
        }
      },1000);
      
    },
    handleSubmit() {
      this.getCode()
      this.handleDeliver();
      this.isHandDialog = true;
      this.isActiveSubmission = true;
      // swal
      //   .swal({
      //     title: `提交后本部分题目将无法修改，确定提交全部题目吗？`,
      //     icon: 'warning',
      //     buttons: ['返回', this.handBtnText],
      //   })

        // .then(async (willSubmit) => {
        //   if (willSubmit) {
        //     try {
        //       this.handleDeliver();
        //       await saveProject({
        //         bundleId: this.params.bundleId,
        //       });
        //       this.showDialog(); 
        //     } catch ({ data }) {
        //       swal.error(data.message);
        //     }
        //   }
        // });
    },
    async handleDeliver(frameData) {
      if (window.frames && window.frames.length > 0) {
        const obj = JSON.stringify({
          type: 'XH_INVOKE_SAVE_PROJECT',
          payload: {
            showMessage: false,
          },
        });
        window.frames[0].postMessage(obj, '*');
      }
      if(window.parent){
        try {
          const params = {
            examId: this.params.examId,
            questionId: this.params.questionId,
          }
          const { data } = await getPracticesSolution(params)
          let payload = {
            // score: data.score,
            // answerTime: data.answerTime,
            // answerDetail: data.answerDetail,
            // questionId: data.questionId,
            // studentId: data.studentId,
            // memory: data.memory,
            type: 'question_finished',
            content: {
              ...data,
              isEncrypt: true, // 传递的分数是加密数据
            }
          }
          if(frameData && frameData.result && frameData.result.answerTime){
            payload.content.answerTime = frameData.result.answerTime
          }
          window.parent.postMessage(
            JSON.stringify(payload),
            '*'
          )
        } catch ( {data} ) {
          let payload = {
            type: 'question_error',
            content: {
              studentId: this.params.studentId,
              questionId: this.params.questionId,
            }
          }
          window.parent.postMessage(
            JSON.stringify(payload),
            '*'
          )
          // loading.hide();
          this.$vmLoading.hide()
          errorHandler(data)
        }
      }
    },
    async handlePaperEnsure(evt) {
      this.solutionError = false
      const answer = JSON.stringify(evt.obj[0].data);
      const isRight = flatMapDeep(evt.obj[0].result).every(item => item === 1);
      try {
        if (!evt.isSame) {
          await updatePaperAnswer({
            answer,
            bundleId:this.params.bundleId,
            questionId: evt.questionId,
            type: evt.type,
            ratio: evt.ratio,
            // result: isRight === true ? 1 : 2,
            resultStr: window.btoa(`${isRight === true ? 1 : 2}_${new Date().getTime()}`),
            practiceId: this.params.bundle[this.index].practiceId
          });
        }

        await this.updateStatus();
        if (this.params.bundleExamStatus === 0) {
          this.handleNext();
        }
      } catch ({ data }) {
        this.solutionError = true
        errorHandler(data)
      }
    },
    handlePaperNext() {
      this.handleNext()
    },
    handleCppPage(e) {
      if (e.pageStatus === 'homepage') {
        this.isShowOverlay = true;
      } else if (e.pageStatus === 'subpage') {
        this.isShowOverlay = false;
      }
    },
    async handleCppFinish() {
      await this.handleUpdate();
      this.handleNext();
    },
    selectIndex(e) {
      this.index = e.index;
      this.practiceIndex = e.index
    },
    genBackCSS() {
      const arr = ['eachendcompiler--back', 'fontweight500'];
      const { category } = this.params.bundle[this.index];
      if ([1].includes(category)) arr.push('eachendcompiler--back-cm');
      if ([2, 7].includes(category)) arr.push('eachendcompiler--back-scratch');
      if ([3, 4, 6, 5, 8, 9].includes(category)) arr.push('eachendcompiler--back-cpp');
      return arr;
    },
    genHandCSS() {
      const arr = ['eachendcompiler--back', 'fontweight500'];
      const { category } = this.params.bundle[this.index];
      if ([1].includes(category)) arr.push('eachendcompiler--hand-cm');
      if ([2, 7].includes(category)) arr.push('eachendcompiler--hand-scratch');
      if ([3, 4, 6, 5, 8, 9].includes(category)) arr.push('eachendcompiler--hand-cpp');
      return arr;
    },
    handleBack() {
      this.handleDirectBack();
    },
    handleDirectBack() {
      this.$router.push(this.back);
      // loading.hide();
      this.$vmLoading.hide()
    },
    // handleDeliver() {
    //   if (window.frames && window.frames.length > 0) {
    //     const { protocol, host } = window.location;
    //     const targetOrigin = `${protocol}//${host}`;
    //     const obj = JSON.stringify({
    //       type: 'XH_INVOKE_SAVE_PROJECT',
    //       payload: {
    //         showMessage: false,
    //       },
    //     });
    //     window.frames[0].postMessage(obj, targetOrigin);
    //   }
    // },
    handleLoaded() {
      this.isShowOverlay = true;
    },
    async handleUpdate(payload) {
      // if (e && e.result === 0) {
      //   this.params.bundle[this.index].correct = false;
      //   this.params.bundle[this.index].finish = true;
      // } else if (e && e.result === 1) {
      //   this.params.bundle[this.index].correct = true;
      //   this.params.bundle[this.index].finish = true;
      // } else {
      //   try {
      //     await this.updateStatus();
      //   } catch ({ data }) {
      //     errorHandler(data)
      //   }
      // }
      try {
        await this.updateStatus(payload);
      } catch ({ data }) {
        errorHandler(data)
      }
    },
    async updateStatus(payload) {
      
      return new Promise((resolve, reject)=>{
        let data = null
        this.destroySolutionTimer()
        if(this.params.role !== '0'){
          const handleSolution = (isRetry) =>{
            updateBundle({
              practiceId: this.params.bundle[this.index].practiceId,
              category: this.params.bundle[this.index].category,
              projectId: this.params.bundle[this.index].projectId,
              bundleId: this.params.bundleId,
              isExam: true
            }).then((res)=>{
              data = res.data
              if (!data) {
                if (isRetry) {
                  reject('')
                  this.solutionError = true
                  this.$elMessage.error('网络异常，请重试');
                } else {
                  this.destroySolutionTimer()
                  this.solutionTimer = setTimeout(async ()=>{
                    handleSolution(true)
                  }, 200)
                }
              } else {
                this.params.bundle[this.index].correct = data.correct;
                this.params.bundle[this.index].finish = data.finish;
                let theDifference = 0;
                if(this.params.bundle[this.index].score){
                  const score = this.params.bundle[this.index].score === '-' ? '0' : this.params.bundle[this.index].score
                  theDifference = data.score - score;
                }
                this.params.totalScore = Number(this.params.totalScore) + Number(theDifference)
                this.params.bundle[this.index].score = data.score;
                // 竞赛 => 每完成一道题保存一下
                this.handleDeliver(payload).then(resolve);
              }
            }).catch((e)=>{
              reject(e)
            })
          }
          handleSolution()
        } else {
          // this.handleDeliver(payload);
          resolve()
        }
        
      })
    },
    async handleChoiceEnsure(e) {
      try {
        await updateStudentAnswer({
          answerId: e.answerId,
          chooseAnswer: e.chooseAnswer,
          // isCorrect: e.isCorrect,
          isCorrectStr: window.btoa(`${e.isCorrect}_${new Date().getTime()}`),
          questionId: e.questionId,
          bundleId:this.params.bundleId
        });
        await this.updateStatus();
        if (this.params.bundleExamStatus === 0) {
          this.handleChoiceFinish();
        }
      } catch ({data} ) {
        this.solutionError = true
        errorHandler(data)
      }
    },
    handleChoiceFinish() {
      this.handleNext();
      // if (this.index < this.params.bundle.length - 1) {
      //   this.index += 1;
      // } else if (this.index === this.params.bundle.length - 1) {
      //   // this.$message.showMessage({info: '已经是最后一题啦！'})
      //   // swal.swal({
      //   //   title: '提示',
      //   //   text: '已经是最后一题了！',
      //   //   icon: 'info',
      //   //   buttons: ['确定'],
      //   // });
      // }
    },
    // async handleCmRun(e) {
    //   try {
    //     this.isShowReel = false;
    //     await saveCMStars(e);
    //   } catch ({ data }) {
    //     swal.error(data.message);
    //   }
    // },
    async handleCmReport(e) {
      try {
        this.isShowReel = false;
        await saveCMUrl(e);
      } catch ({ data }) {
        errorHandler(data)
      }
    },
    async handleCmFinish() {
      try {
        this.isShowReel = true;
        // await saveCMUrl(e);
        await this.updateStatus();
        this.handleNext();
        if (this.index === this.params.bundle.length - 1) {
          this.isCmLast = true;
        }
      } catch ({ data }) {
        errorHandler(data)
      }
    },
    handleCmRetry() {
      this.isShowReel = true;
    },
    handleSaved() {
      window.parent.postMessage(
        JSON.stringify({
          type: 'question_saved',
          content: {
            studentId: this.params.studentId,
            questionId: this.params.questionId,
          }
        }),
        '*'
      )
    },

    handleIframeMessage(event) {
      let data = event.data
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data)
        } catch (error) {
          return
        }
      }
      if (!data || data.type !== 'XH_SCRATCH_DESCRIPTION') return
      const payload = data.payload || {}
      this.hbsParams = Object.assign({}, this.hbsParams, {
        description: payload.description || '',
        footerIcon: payload.footerIcon || this.hbsParams.footerIcon || 'light',
        hideTools: !!payload.hideTools
      })
    },

    // 猴博士相关
    async initHbsData(params) {
      const {
        bundle: bundleList,
        courseId,
        bundleId,
        lessonId,
      } = params;
      const {
        category,
        projectId,
        practiceId,
      } = bundleList[this.index];
      this.hbsParams = Object.assign({}, {
        compilerType: category,
        projectId,
        courseId,
        bundleId,
        lessonId,
        practiceId,
        description: this.hbsParams.description || '',
        footerIcon: this.hbsParams.footerIcon || 'light',
        hideTools: !!this.hbsParams.hideTools,
      });
    },

    handleHbsData(val) {
      Promise.resolve()
        .then(() => {
          this.hbsDataloaded = false;
        })
        .then(() => {
          this.initHbsData(val);
        })
        .then(() => {
          setTimeout(() => {
            this.hbsDataloaded = !this.cppCategoryList.includes(val.bundle[this.index].category)
              && !this.notShowHBSCtype.includes(val.bundle[this.index].pythonType);
            this.isShowPython = this.params.bundle[this.practiceIndex].pythonType !== 12;
          }, 500);
        });
    },
    modifyTitle() {
      this.$refs.modifysa.showQuit();
    },
    destroyEventsource() {
      if (this.xeventsource) {
        this.xeventsource.destroy();
        this.xeventsource = null;
      }
      if (this.eventsourceTimer) {
        clearTimeout(this.eventsourceTimer)
        this.eventsourceTimer = null
      }
    },
    creatEventsource() {
      // 创建eventsource
      // eslint-disable-next-line no-console
      console.log('----studentCompiler----：开始创建链接')
      this.destroyEventsource();
      this.xeventsource = new XEventSource(`${process.env.VUE_APP_URL}/api/competition/sse/competition/end/${this.params.bundleId}/${this.params.timingType}?token=${this.params.token}`);
      // eslint-disable-next-line no-console
      console.log('----studentCompiler----：已创建链接')
      this.xeventsource.on('message', (resp) => {
        // eslint-disable-next-line no-console
        console.log('----studentCompiler----：收到消息', resp)
        try {
          if (resp.data === '1') {
            // this.modal.title = '题目收取成功';
            // this.modal.label = '竞赛时间结束，已提交最新答题结果！';
            // this.modal.btnLabel = '确定';
            // this.isNeedDialog = true;
            // 记录提交时间
            recordSubmitTime({
              competitionId: this.competitionId,
              bundleId: this.params.bundleId,
              type: 2
            })
            this.isHandDialog = true;
            this.isActiveSubmission = false;
            this.handleDeliver();
            this.destroyEventsource();
            this.$vmLoading.hide()
          }
          // if (resp.lastEventId == 8) {
          //   xeventsource.destroy()
          //   this.eventsourceTimer = setTimeout(()=>{
          //     this.creatEventsource()
          //   }, 1000)
          // }
        } catch (err) {
          // console.log(err);
        }
      });
      this.xeventsource.on('error', () => {
        // eslint-disable-next-line no-console
        console.log('----studentCompiler----：error')
        this.destroyEventsource();
        this.eventsourceTimer = setTimeout(()=>{
          this.creatEventsource()
        }, 1000)
      });
    },
    destroySolutionTimer() {
      if (this.solutionTimer) {
        window.clearTimeout(this.solutionTimer)
        this.solutionTimer = null
      }
    },
    setAppFocus() {
      this.updateFocusState(true, 'app')
    },
    setAppBlur(e) {
      // 聚焦子编辑器时，会触发父编辑器失焦，如果此时直接判断，子编辑器也是失焦，会上报一次失焦事件，所以延迟一点再判断
      // input textarea 失焦时，会触发父编辑器失焦，这种情况不需要上报失焦事件
      if (e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA') return
      // blur 不冒泡；监听 window 自身事件，页面内部控件失焦不会进入这里
      setTimeout(() => {
        this.updateFocusState(false, 'app')
      }, 20)
    },
    markSuppressNextBanoutBlur() {
      this.suppressNextBanoutBlur = true
      if (this.suppressBanoutBlurTimer) {
        clearTimeout(this.suppressBanoutBlurTimer)
      }
      this.suppressBanoutBlurTimer = setTimeout(() => {
        this.suppressNextBanoutBlur = false
        this.suppressBanoutBlurTimer = null
      }, 300)
    },
    handleHbsClose() {
      this.markSuppressNextBanoutBlur()
    },
    updateFocusState(state, from) {
      if (!this.params.startBanOut) return
      if (!state && from === 'app' && this.suppressNextBanoutBlur) {
        this.suppressNextBanoutBlur = false
        return
      }
      if (document.activeElement.nodeName === 'IFRAME' && from === 'compiler') {
        if (state) {
          if (!this.focus) {
            this.focus = true
          }
        } else {
          if (this.focus) {
            this.focus = false
          }
        }
      } else if (document.activeElement.nodeName !== 'IFRAME' && from === 'app') {
        if (state) {
          if (!this.focus) {
            this.focus = true
          }
        } else {
          if (this.focus) {
            this.focus = false
          }
        }
      }
    },
    
  },

  async created() {
    const { token, role, questionId, examId, canSave, studentId, realName, judgeType, startBanOut, startBanCopy, questionIndex, questionCount, showHighest } = this.$route.query;

    const userInfo = {
      realName: realName ? realName : '',
      id: studentId,
      card: studentId,
      accessToken: token,
    }
    this.$store.dispatch('saveAutoLoginInfo', userInfo)

    // 判断猿圈传输了参数
    if(token){
      // 接口 TODO
      try {
        const params = {
          examId,
          questionId,
        }
        const res = await getSubjectSpractice(params)
        // 数据
        this.params = {
          examId,
          questionId,
          studentId,
          bundleId: examId,
          role,
          fr: 'oxcoder',
          token,
          canSave: !!Number(canSave),
          projectType: 1,
          practiceType: null,
          bundleExamStatus: 0,
          timingFlag: -1,
          totalScore: "",
          judgeType,
          showHighest: showHighest ? Number(showHighest) : 0, // 是否显示最高分
          startBanOut: Number(startBanOut), // 猿圈用于检测是否有切出页面
          startBanCopy: Number(startBanCopy), // 是否开启监听复制事件
          questionIndex: Number(questionIndex), // 当前题目索引
          questionCount: Number(questionCount), // 题目总数
          isLastQuestion: Number(questionIndex) === Number(questionCount) - 1, // 是否是最后一题
          bundle: [
            res.data
          ],
        }
      } catch ( {data} ) {
        // loading.hide();
        this.$vmLoading.hide()
        errorHandler(data)
      }
    } else {
      this.$vmLoading.hide()
      errorHandler("参数错误")
    }

    if (this.params.startBanOut) {
      window.addEventListener('focus', this.setAppFocus, true)
      window.addEventListener('blur', this.setAppBlur, false)
    }
    
    return
    // 暂时保留
    // try {
    //   // loading.show();
    //   const { data } = await getSubject({ bundleId });
    //   if (!data) return  
    //   this.isShowPython = data.practices[0].pythonType !== 12;
    //   this.params = {
    //     bundleId,
    //     firstOpenTime: Number(data.firstOpenTime),
    //     countDownTime: data.countDownTime,
    //     timingType: data.timingType,
    //     bundle: data.practices,
    //     lessonId: data.lessonId,
    //     practiceType: data.bundleTag,
    //     canLook: data.canLook,
    //     canSave: data.canSave,
    //     canSubmit: data.canSubmit,
    //     allowCommit: data.allowCommit,
    //     projectType: data.projectType,
    //     handleIndex: data.title,
    //     competitionEnd: data.competitionEnd,
    //     bundleExamStatus:data.bundleExamStatus,
    //     timingFlag:data.timingFlag,
    //     totalScore:data.totalScore
    //   };
    //   // 参数修正
    //   this.params.token = ''
    //   // if(this.isSerial){
    //     const tokenKey = !this.$route.query.id ? `NOC_XILIE_CP_2023` : `NOC_XILIE_CP_69a9b069e7d4b434887d06927d2c5dfc` 
    //   // }else{
    //   //   this.params.token = JSON.parse(localStorage.getItem(this.tokenKey)).token || JSON.parse(localStorage.getItem(this.tokenKey)).accessToken;
    //   // }
      
    //   this.isNeedSubmit = !data.submited
    //   // this.isNeedDialog = data.submited
    //   // data.submited && this.showDialog();
    //   // if(data.submited){
    //   //    this.isHandDialog = true;
    //   //    this.isClearTimer = true;
    //   //    this.isAlreadySubmit = true;
    //   //    this.$vmLoading.hide()
    //   // } else {
    //   //   recordStartAnswerTime({
    //   //     competitionId: this.competitionId,
    //   //     bundleId: this.params.bundleId
    //   //   })
    //   // }

    // } catch (  {data}  ) {
    //   // loading.hide();
    //   this.$vmLoading.hide()
    //   errorHandler(data)
    // }

    

    // // 竞赛 & 未收题 => 创建轮训链接
    //   this.isNeedCorrect = true;
    //   this.isNeedPre = true;
    //   try {
    //     const res = await getCompetitionStatus({
    //       bundleId: this.params.bundleId,
    //       timingType: this.params.timingType
    //     });
    //     this.isNeedPre = false;
    //     if (res.data === 0 && !this.isAlreadySubmit) {
    //       const r = +(new Date()) % 10;
    //       this.eventsourceTimer = setTimeout(() => {
    //         this.creatEventsource()
    //       }, r * 1000);
    //     } else {
    //       // this.modal.title = '题目收取成功';
    //       // this.modal.label = '竞赛时间结束，已提交最新答题结果！';
    //       // this.modal.btnLabel = '确定';
    //       // this.isNeedDialog = true;
    //       this.isHandDialog = true;
    //       this.isClearTimer = true;
    //       this.isActiveSubmission = false;
    //       this.$vmLoading.hide()
    //     }
    //   } catch ({ data }) {
    //     errorHandler(data)
    //   }
  },
  mounted() {
    window.addEventListener('message', this.handleIframeMessage)
  },
  beforeDestroy() {
    this.destroyEventsource();
    this.destroySolutionTimer();
    if (this.suppressBanoutBlurTimer) {
      clearTimeout(this.suppressBanoutBlurTimer)
      this.suppressBanoutBlurTimer = null
    }
    window.removeEventListener('message', this.handleIframeMessage)
    window.removeEventListener('focus', this.setAppFocus, true)
    window.removeEventListener('blur', this.setAppBlur, false)
    
  },

  watch: {
    index() {
      this.destroySolutionTimer()
      this.handleHbsData(this.params);
    },
    params: {
      handler(newVal) {
        this.initHbsData(newVal);
        this.hbsDataloaded = !this.cppCategoryList.includes(this.params.bundle[this.index].category)
          && !this.notShowHBSCtype.includes(this.params.bundle[this.index].pythonType);
      },
      deep: true,
    },
    focus(val) {
      window.parent.postMessage(
        JSON.stringify({
          type: val ? 'banout_focus' : 'banout_blur'
        }),
        '*'
      )
    }
  },
};
</script>

<style
  scoped
  lang="less"
  rel="stylesheet/less"
  src="@/assets/less/compiler/eachend.less"
>
</style>
<style lang="less">
.swal-title{
  font-size: 24px;
}
.hand{
  .header{
    text-align: center;
    margin-top:25px;
    font-size: 24px;
    color:#333;
    font-weight: 500;
  }
  .eachendcompiler--dialog{
    height: 302px;
  }
  .hand_btn{
    display: flex;
    justify-content: center;
    margin-top:40px;
    .eachendcompiler--dialog-btn{
      margin:0 10px;
      width: 140px;
      &.back{
        background: #FCEBCB;
        color:#6B4C2E;
      }
      &.submit{
        background: #68953C;
      }
      &.down_count{
        background: #BEBEBE;
      }
    }
  }
  .eachendcompiler--dialog-txt{
    h5{
      color:#333;
      width: 318px;
      margin:0 auto;
    }
  }
  .eachendcompiler--dialog-icon{
    width: 50px;
    height: 50px;
    margin-top:32px;
    background: url('~@/assets/mark_icon.png') no-repeat center;
    background-size:50px 50px ;

  }
}
</style>
